<template>
  <div>
    <h3 class="mb-2 px-1">
      {{ $t("counselings.transferTitle") }}
    </h3>
    <div class="col-12">
      <b-col>
        <b-form-group :label="$t('counselings.lastCounseling')">
          <v-select-custom
            v-model="lastConsultantId"
            :options="userOptions1"
            :custom-props="{ label: 'fullName' }"
            @open="fetchUsersByRole1({ role: 'consultant' })"
            @search="fetchUsersByRole1({ role: 'consultant', search: $event })"
          />
        </b-form-group>
        <!-- <span v-if="counselingChats">تعداد آیتم ها : {{ counselingChats.length }}</span> -->
        <div
          v-if="lastConsultantId"
          class="alert alert-danger p-1"
          role="alert"
        >
          <p>
            - برای انتقال
            <strong>همه ی پیام های مشاور قدیم به مشاور جدید</strong>, روی انتخاب همه کلیک
            کنید.
          </p>
          <p>
            - اگر می خواهید <strong>تعدادی از کاربرها</strong>  را انتقال دهید, روی کدهای مورد نظر کلیک کنید و  سپس انتقال مشاور را کلیک نمایید.
          </p>
        </div>
      </b-col>
    </div>
    <div v-if="userOptions1">
      <BDataTable
        ref="refTable"
        :fetch-list="fetchList"
        :table-columns="tableColumns"
        :searchable="false"
        :filters="filters"
        :selectable="true"
        select-mode="multi"
        :show-select-all-switch-button="true"
        @selectedItems="selectedItems"
      >
        <!-- Column: status -->
        <template #cell(status)="{ item }">
          <pill-icon-cell :status="$t(`counselings.${item.status}`)" />
        </template>
        <!-- Column: Actions -->
      </BDataTable>
    </div>
    <div class="col-12 mt-3 mb-1 hr-sec px-2">
      <div class="lable-hr">
        {{ $t("counselings.couselingTo") }}
      </div>
    </div>
    <div class="col-12">
      <b-col>
        <b-form-group :label="$t('counselings.newCounseling')">
          <v-select-custom
            v-model="newConsultantId"
            :options="userOptions2"
            :custom-props="{ label: 'fullName' }"
            @open="fetchUsersByRole2({ role: 'consultant' })"
            @search="fetchUsersByRole2({ role: 'consultant', search: $event })"
          />
        </b-form-group>
      </b-col>
    </div>
    <div class="col-12">
      <b-col>
        <b-button
          v-if="newConsultantId"
          id="transferCounselingBtn"
          style="margin-top: 27px !important"
          size="md"
          variant="outline-primary"
          class="btn btn-primary mr-1"
          @click="showModalTransfer"
        >
          <span class="text-nowrap">{{ $t("counselings.transferCounseling") }}</span>
        </b-button>
      </b-col>
    </div>
    <div
      v-if="ModalTransferCounselings"
      class="modalTransfer"
      tabindex="-1"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              انتقال مشاور
            </h5>
            <button
              type="button"
              class="btn btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="CloseModalTransfer"
            >
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>ایا از انتقال {{ selectedItemsForTransfer.length }} مشاور مطمئن هستید؟</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-success"
              @click="transferCounselings"
            >
              انتقال
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-bs-dismiss="modal"
              @click="CloseModalTransfer"
            >
              کنسل
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCol, BFormGroup, BButton } from 'bootstrap-vue'
import VSelectCustom from '@/components/VSelectCustom/index.vue'
import useCounselingsList from '@/views/pages/counseling/useCounselingsList'
import BDataTable from '@/components/BDataTable/index.vue'
import PillIconCell from '@/components/BDataTable/Elements/PillIconCell.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'PagesCounselingTransfer',
  components: {
    VSelectCustom,
    BCol,
    BDataTable,
    PillIconCell,
    BFormGroup,
    BButton,
  },
  setup() {
    const {
      fetchList,
      fetchUsersByRole,
      fetchUsersByRole1,
      fetchUsersByRole2,
      userOptions,
      userOptions1,
      userOptions2,
      tableColumns,
      transferCounseling,
      fetchCounseling1,
      refTable,
    } = useCounselingsList()
    return {
      fetchList,
      fetchUsersByRole,
      fetchUsersByRole1,
      fetchUsersByRole2,
      userOptions,
      userOptions1,
      userOptions2,
      tableColumns,
      transferCounseling,
      fetchCounseling1,
      refTable,
    }
  },
  data() {
    return {
      consultantOptions: [],
      lastConsultantId: null,
      newConsultantId: null,
      consultantChatIds: null,
      showChangeModalBox: false,
      counselingChats: [],
      consultantId: null,
      usersId: [],
      CounselingId: [],
      numCounselingId: [],
      ModalTransferCounselings: false,
      checkboxes: [],
      CounselingIdNew: [],
      checked: false,
      selectedItemsForTransfer: [],
    }
  },
  computed: {
    filters() {
      return {
        consultantId: this.lastConsultantId && this.lastConsultantId._id,
        userId: this.userId && this.userId._id,
      }
    },
  },
  watch: {
    consultantId(newData) {
      this.refTable.refetchData()
      this.fetchCounseling1(newData._id).then(res => {
        this.counselingChats = res.data
      })
    },
    userId() {
      this.refTable.refetchData()
    },
    lastConsultantId(newData) {
      this.refTable.refetchData()
      this.fetchCounseling1(newData._id).then(res => {
        this.counselingChats = res.data
      })
    },
  },
  created() {
    this.fetchUsersByRole1({
      role: 'consultant',
    }).then(res => {
      this.consultantOptions = res
    })
    this.fetchUsersByRole1({
      role: 'user',
    }).then(res => {
      this.userOptions1 = res
    })
  },
  methods: {
    // SelectAll() {
    //   if (this.isChecked) {
    //     this.CounselingId = this.$refs.refTable.items.map((item) => item._id);
    //     this.numCounselingId = this.CounselingId.length;
    //     this.checkboxes = document.getElementsByTagName("input");
    //     this.checkboxes.forEach((checkbox) => {
    //       checkbox.checked = true;
    //     });
    //   } else {
    //     this.CounselingId = [];
    //     this.numCounselingId = 0;
    //     this.checkboxes = document.querySelectorAll('table input[type="checkbox"]');
    //     this.checkboxes.forEach((checkbox) => {
    //       checkbox.checked = false;
    //     });
    //   }
    // },
    showModalTransfer() {
      this.ModalTransferCounselings = true
    },
    CloseModalTransfer() {
      this.ModalTransferCounselings = false
    },
    transferCounselings() {
      const payload = {
        ids: [],
        consultantId: '',
      }
      const variant = 'primary'
      const timeout = 4000
      if (this.counselingChats && this.selectedItemsForTransfer) {
        for (let i = 0; i < this.selectedItemsForTransfer.length; i += 1) {
          payload.ids.push(this.selectedItemsForTransfer[i])
        }
        payload.consultantId = this.newConsultantId._id
      }
      if (this.selectedItemsForTransfer.length !== 0) {
        this.transferCounseling(payload).then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'انتقال مشاوره',
              icon: 'BellIcon',
              text: 'عملیات با موفقیت انجام شد',
              variant,
            },
          }, {
            timeout,
          })
          this.$router.push({
            name: 'pages-counseling-list',
          })
        })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'انتقال مشاوره انجام نشد',
            icon: 'BellIcon',
            text: ' مشاورهای مورد نظر را انتخاب نمایید',
            variant: 'danger',
          },
        }, {
          timeout,
        })
      }
    },
    selectedItems(items) {
      this.selectedItemsForTransfer = items.map(item => item._id)
    },
  },
}
</script>
